import useAuth from '../../component/useAuth';
import Template from '../../component/Template';
import { useEffect } from 'react';
import Api from '../../component/Api';
import { useState } from 'react';
import React, { useRef } from "react";
import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';

import $ from 'jquery';
import 'datatables.net';
import 'datatables.net-bs4/css/dataTables.bootstrap4.min.css';

import logo from "../../Assets/images/gif/danger.gif";

// for showing tost 
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { toast } from 'react-toastify';

//for exporting the table into excel sheet
import { useDownloadExcel } from 'react-export-table-to-excel';
window.$ = window.jQuery = $;

export default function EmailUpdate() {

  const navigate = useNavigate();

  //validating user credintial again to ensure he is loged in 
  const isAuth = useAuth();
  if (isAuth === false) {
    navigate("/admin/")
  }

  const [faculty, setFacultyData] = useState([]);
  const [isUpdate, setUpdate] = useState(false);
  const [pagereload, setPageReload] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [sortBy, setSortBy] = useState({ column: null, direction: 'asc' }); //sort
  const { http } = Api();

  const [isAccess, setAccess] = useState({
    addFaculty: false,
    viewFaculty: false,
    updateFaculty: false,
    deleteFaculty: false
  });


  const [showModal, setShowModal] = useState(false); // State to control modal visibility 20/3/2024
  const [selectedFaculty, setSelectedFaculty] = useState(null); // State to store selected faculty
  const [selectedFacultyname, setSelectedFacultyName] = useState(null);
  const [selectedFacultydate, setSelectedFacultyDate] = useState(null);
  const [selectedFacultyrem, setSelectedFacultyRem] = useState(null);


  const [editingId, setEditingId] = useState(null);

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = String(date.getFullYear());
    return `${day}-${month}-${year}`;
  };

  // cheacking user  role  to assign 
  useEffect(() => {
    const access = async () => {
      const { http } = Api();
      const id = localStorage.getItem("id");
      try {
        const response = await http.get('/Admin/get-all-user-permissions', { params: { user_id: id } });
        const permissions = response.data.map(permission => permission.name);

        const hasAddFacultyPermission = permissions.includes("add-faculty");
        const hasViewFacultyPermission = permissions.includes("view-faculty");
        const hasUpdateFacultyPermission = permissions.includes("update-faculty");
        const hasDeleteFacultyPermission = permissions.includes("delete-faculty");

        setAccess({
          addFaculty: hasAddFacultyPermission,
          viewFaculty: hasViewFacultyPermission,
          updateFaculty: hasUpdateFacultyPermission,
          deleteFaculty: hasDeleteFacultyPermission
        });
      } catch (error) {
        console.error("Error fetching user roles:", error);
      }
    };
    access();
  }, []);

  useEffect(() => {

    fetchData();
  }, []);

  const tableRef = useRef(null);
  const [emailData, setEmailData] = useState([]);

  const fetchData = async () => {

    try {
      const response = await http.get('/getDuplicateMail');
      setEmailData(response.data);

      const dataTable = $('#dataTable').DataTable();
      if (dataTable) {
        dataTable.destroy();
      }
      $('#dataTable').DataTable({
        pageLength: 50,
        autoWidth: false,
        responsive: true,
        columnDefs: [
          { targets: "_all", className: "dt-center" },
        ]
      });
    } catch (error) {


      if (error.response.data.http_status === 401) {
        toast.error("Invalid token");
        setTimeout(() => {
          navigate('/college/');
        }, 5000);
      } else if (error.response.data.http_status === 500) {
        toast.error("Data not found");
      } else {
        console.error("Error in getDuplicateMail:", error);
        toast.error("Something went wrong: ");
      }
    }
  };
  // Empty dependency array ensures this effect runs only once on component mount


  const handleEdit = (id) => {
    setEditingId(id);
  };

  const handleConfirmUpdate = async (id) => {
    const editedFaculty = emailData.find(item => item.id === editingId);


    if (!editedFaculty) {
      toast.error("No faculty found for update.");
      return;
    }
    const { apaar_no, student_email } = editedFaculty;

    // alert(apaar_no);
    // alert(student_email);

    await http.post('/updateEmail', {
      apaar_no: parseInt(apaar_no),
      email: student_email,
    }).then(response => {
      if (response.data.status_code === "MSG12" && response.data.http_status === 200) {
        toast.success("Email updated successfully!");
        setEditingId(null);
        setUpdate(false);
        setTimeout(() => {
          window.location.reload();
        }, 3000);
      }
      else if (response.data.status_code === "ERR3" && response.data.http_status === 500) {
        toast.error("Error While Updating Email");
        setUpdate(false);
        setTimeout(() => {
          window.location.reload();
        }, 3000);


      }
    }).catch(error => {
      toast.error("Failed to update email");
      console.error("Error updating email:", error);
      setUpdate(false);
      setTimeout(() => {
        window.location.reload();
      }, 5000);


    })
  };

  const handleChange = (id, field, value) => {
    setEmailData((prevData) =>
      prevData.map((item) =>
        item.id === id ? { ...item, [field]: value } : item
      )
    );
  };

  const Canceleditpage = () => {
    setEditingId(null);
    //window.location.reload();
    setUpdate(false);
    fetchData();


  }



  const [ismobile, setIsmobile] = useState(false);
  const togglemenu = () => {
    setIsmobile(!ismobile);
  };

  const [showFilter, setShowFilter] = useState(false); // State to control filter section visibility
  const toggleFilter = () => {
    setShowFilter(!showFilter); // Toggle filter section visibility
  };



  return (
    <>
      <ToastContainer /> {/*  to display toast */}
      <Template>  {/*  to display header footer sidebar */}






        <div className={`modal fade show ${isUpdate ? 'd-block' : ''}`} id="exampleModalCenter1" tabIndex="-1" role="dialog" aria-labelledby="exampleModalCenter1" aria-model="true">
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content">
              <div className="modal-body">
                <div className="modal-toggle-wrapper">
                  {/* <ul className="modal-img">
                    <li> <img src={logo} /></li>
                  </ul> */}
                  <h4 className="text-center pb-2">Are you sure you want to update Email?</h4>
                  <p className="text-center">Once the email has been updated, it cannot be changed again.</p>
                  <div className="d-flex justify-content-center mt-3">

                    <button className="btn btn-danger mx-2" onClick={handleConfirmUpdate}>Update</button>
                    <button className="btn " style={{ backgroundColor: 'white', borderColor: 'red', color: 'black' }} data-bs-dismiss="modal" onClick={() => Canceleditpage()}>Cancel</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>




        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-12 col-md-12 col-sm-12">
              <div className="card">
                <div className="card-header card-heading">
                  <div className="py-3 d-flex justify-content-between align-items-center">
                    <h5 className="lbl1">Email Update Requests</h5>
                    <div className="d-flex ml-auto">
                      {/* Responsive Dropdown or Hamburger Menu */}
                      {/* <div className="dropdown d-lg-none">
                        <button
                          className="btn btn-light dropdown-toggle"
                          type="button"
                          id="mobileActionsDropdown"
                          data-toggle="dropdown"
                          aria-haspopup="true"
                          aria-expanded={ismobile}
                          onClick={togglemenu}
                        >
                          <i className="fas fa-bars"></i>
                        </button>
                        <div
                          className={`dropdown-menu dropdown-menu-right ${ismobile ? 'show' : ''}`}
                          aria-labelledby="mobileActionsDropdown"
                          style={{
                            margin: '10px 20px 20px -60px',
                            boxShadow: '0 0 10px rgba(0, 0, 0, 0.1)',
                            borderRadius: '0.5rem',
                            overflow: 'hidden',
                            color: 'black',
                          }}
                        >
                          <a
                            className="dropdown-item"
                            onClick={() => {
                              toggleFilter();
                              togglemenu();
                            }}
                          >
                            <i
                              className={`bi ${showFilter ? 'bi-x-circle-fill' : 'bi-funnel-fill'} show`}
                              aria-hidden="true"
                              style={{ cursor: "pointer", color: 'black' }}
                            > Filter</i>
                          </a>
                          <div className="dropdown-divider my-0"></div>
                        </div>
                      </div> */}


                      {/* Desktop View */}
                      {/* <div className="d-none d-lg-flex">
                        <div className="light-box">
                          <a style={{ marginLeft: "10px" }} onClick={toggleFilter} className="btn btn-light">
                            <i className={`fa fa-filter ${showFilter ? 'icon-close' : 'filter-icon'} show`} aria-hidden="true"></i>
                          </a>
                          &nbsp;&nbsp;
                        </div>
                      </div> */}
                    </div>
                  </div>
                </div>

                <div className={`collapse ${showFilter ? 'show' : ''}`} id="collapseProduct" style={{ margin: "20px 20px 20px 20px" }}>
                  <div className="card card-body list-product-body">
                    {/*23/3/2024-filter*/}
                    <div className="row row-cols-xl-5 row-cols-lg-4 row-cols-md-3 row-cols-sm-2 row-cols-2 g-3">
                      <div className="col">
                        <select className="form-select " aria-label="Default select example">
                          <option value={null}>Select Admission Year</option>
                        </select>
                      </div>
                      <div className="col">
                        <button className="btn btn-primary" onClick={() => window.location.reload()} style={{ width: "100%" }}>Clear All</button>
                      </div>
                    </div>
                  </div>
                </div>
                {emailData.length ? (
                  <div className="card-body">
                    <div className="table-responsive">
                      <table className="display dataTable table-bordered text-left" id="dataTable" ref={tableRef}>
                        <thead>
                          <tr className="bg-primary text-center">
                            <th>Sl No</th>
                            <th width="">APAAR No.</th>
                            <th width="">Aadhaar No.</th>
                            <th width="">Name</th>
                            <th width="">Existing Email-Id</th>
                            <th>Admission year</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody style={{ textAlign: 'right' }}>
                          {Array.isArray(emailData) && emailData.map((row, index) => (
                            <tr key={row.id}>
                              <td>{index + 1}</td>
                              <td>{row.apaar_no}</td>
                              <td>{row.aadhar_no}</td>
                              <td>{row.studentname}</td>
                              <td>
                                {editingId === row.id ? (
                                  <form onSubmit={(e) => { e.preventDefault(); setUpdate(true); }} >
                                    <input type="text" id="student_email" name="student_email"
                                      value={row.student_email}
                                      onChange={(e) => handleChange(row.id, 'student_email', e.target.value)}
                                    /></form>
                                ) : (
                                  row.student_email
                                )}
                              </td>
                              <td>{row.admissionyear}</td>
                              <td className="col-cha-tab-td">
                                <ul className="action">
                                  <li className={editingId === row.id ? "submit" : "edit"}>

                                    {editingId === row.id ? (
                                      <>
                                        <a onClick={() => setUpdate(true)}> {/* Show the modal when clicking on this icon */}
                                          <i className="fa fa-check col-edt-icn-clr"></i>
                                        </a>
                                        <a onClick={() => Canceleditpage(null)}> {/* Close editing mode */}
                                          <i className="fa fa-close col-clos-icn-clr"></i>
                                        </a>
                                      </>
                                    ) : (
                                      <a onClick={() => handleEdit(row.id)}>
                                        <i className="icon-pencil-alt col-edt-icn-clr"></i>
                                      </a>
                                    )}

                                  </li>
                                </ul>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                ) : (
                  <div className="card-body">
                    <div className="card-body pdg1">
                      <div className="table-responsive txt-aln">
                        No Data Available..
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>



      </Template >
    </>
  );
}
